/** Client-side rollup when /admin/reports/space-bookings is unavailable */

function quarterOfMonth(monthIndex) {
  return Math.floor(monthIndex / 3) + 1;
}

function paymentTotal(booking) {
  const list = booking.payments;
  if (Array.isArray(list) && list.length) {
    return list.reduce((s, p) => s + (Number(p.amount ?? p.payment_amount ?? 0) || 0), 0);
  }
  return Number(booking.paid_amount ?? booking.sum_of_payments ?? 0) || 0;
}

function periodBucket(isoLike, reportType) {
  const d = new Date(isoLike);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  if (reportType === 'yearly') return { key: `y-${y}`, report_year: y };
  if (reportType === 'quarterly') {
    const q = quarterOfMonth(d.getMonth());
    return { key: `q-${y}-${q}`, report_year: y, report_quarter: q };
  }
  return { key: `m-${y}-${m}`, report_year: y, report_month: m };
}

/**
 * Roll up space bookings to match room-report style rows.
 * @param {Array<object>} bookings
 * @param {'monthly'|'quarterly'|'yearly'} reportType
 * @param {{ id:number, name:string }|null} spaceFilter
 */
export function aggregateSpaceBookingsReport(bookings, reportType = 'monthly', spaceFilter = null) {
  if (!Array.isArray(bookings)) return [];

  const map = new Map();

  for (const b of bookings) {
    if (b.status === 'cancelled') continue;
    if (spaceFilter?.id != null && Number(b.space_id) !== Number(spaceFilter.id)) continue;

    const ref = b.date_from || b.booking_date || b.created_at;
    const bucket = periodBucket(ref, reportType);
    if (!bucket) continue;

    const rowKey =
      spaceFilter?.id != null ? bucket.key : bucket.key /* all merged by period */;

    if (!map.has(rowKey)) {
      map.set(rowKey, {
        ...bucket,
        name: spaceFilter?.name || 'جميع المساحات',
        count_booking: 0,
        net_amount: 0,
        sum_of_payments: 0
      });
    }
    const row = map.get(rowKey);
    row.count_booking += 1;
    const total = Number(b.total_price ?? b.total_amount ?? 0) || 0;
    row.net_amount += total;
    row.sum_of_payments += paymentTotal(b);
  }

  return [...map.values()].sort((a, b) => {
    if (a.report_year !== b.report_year) return b.report_year - a.report_year;
    if (reportType === 'monthly') return (b.report_month || 0) - (a.report_month || 0);
    if (reportType === 'quarterly') return (b.report_quarter || 0) - (a.report_quarter || 0);
    return 0;
  });
}
